// loader.component.ts
import {Component, Input} from "@angular/core";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-loader',
    template: `
<!--        <div class="page-loader"></div>-->
        <div class="loader-overlay" *ngIf="isLoading">
            <div class="loader-container">
<!--                <div class="spinner"></div>-->
                <div class="page-loader"></div>
                <div class="loader-text">{{ message }}</div>
            </div>
        </div>
    `,
    standalone: true,
    imports: [
        NgIf
    ],
    styles: [`
      .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }

      .loader-container {
        text-align: center;
      }

      .spinner {
        width: 50px;
        height: 50px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto;
      }

      .loader-text {
        color: #edf6f8;
        margin-top: 15px;
        font-size: 20px;
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `]
})
export class LoaderComponent {
    @Input() isLoading!: boolean | null ;
    @Input() message: string | null = 'Loading ...';
}